import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Observer from 'react-intersection-observer';
import loadPolyfills from '../../../../core/util/polyfills';
import { isEmpty } from '../../../../core/util/empty';
import { isEmptyObject } from '../../../../core/util/object';
import logger from '../../../../core/logger';
import AdditionalInfo from './AdditionalInfo';

class MapAndDirectionsContainer extends Component {
  state = {
    isObserverPolyfillLoaded: false,
    MapAndDirections: null,
    isSectionVisited: false,
  };

  componentDidMount = () => {
    loadPolyfills()
      .then(() =>
        this.setState({
          isObserverPolyfillLoaded: true,
        })
      )
      .catch(e => {
        logger.error('Error loading Intersection Observer polyfill', e);
      });
  };

  shouldRenderMapAndDirections = () => {
    const { isObserverPolyfillLoaded } = this.state;
    const {
      location: { latLong },
    } = this.props;

    return !isEmptyObject(latLong) && isObserverPolyfillLoaded;
  };

  handleObserverChange = inView => {
    const { isSectionVisited, MapAndDirections } = this.state;
    if (inView && !isSectionVisited) {
      this.setState({ isSectionVisited: true });
    }
    if (isEmpty(MapAndDirections)) {
      import(/* webpackChunkName: 'mapAndDirections', webpackPrefetch: true */ './MapAndDirections').then(
        module => {
          this.setState({ MapAndDirections: module.default });
        }
      );
    }
  };

  renderMapAndDirections = () => {
    const { location, enableCollapsing, defaultExpanded } = this.props;
    const { MapAndDirections } = this.state;

    return (
      <MapAndDirections
        location={location}
        enableCollapsing={enableCollapsing}
        defaultExpanded={defaultExpanded}
      />
    );
  };

  render = () => {
    const { isSectionVisited, MapAndDirections } = this.state;

    if (!this.shouldRenderMapAndDirections()) {
      return <AdditionalInfo location={this.props.location} />;
    }

    return (
      <Fragment>
        <Observer onChange={this.handleObserverChange}>
          {(isSectionVisited && MapAndDirections && this.renderMapAndDirections()) || null}
        </Observer>
        <AdditionalInfo location={this.props.location} />
      </Fragment>
    );
  };
}

export default MapAndDirectionsContainer;

MapAndDirectionsContainer.propTypes = {
  location: PropTypes.object.isRequired,
  enableCollapsing: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
};

MapAndDirectionsContainer.defaultProps = {
  location: {
    latLong: {},
  },
};
